import TierAPIService from "../tier_api_service";
import apiUtils from "../../../../core/utils/api_utils";

export default class TierAPIServiceImpl extends TierAPIService {
  static #instance = null;

  constructor() {
    if (TierAPIServiceImpl.#instance) {
      return TierAPIServiceImpl.#instance; // Return existing instance instead of creating a new one
    }
    super(); // Call parent constructor
    TierAPIServiceImpl.#instance = this; // Store instance
  }

  async getActiveTiers() {
    try {
      const response = await apiUtils.get(`/api/tiers/active`);
      return response.data;
    } catch (err) {
      console.log(err);
      return err.response
        ? err.response.data
        : { success: false, message: "Something went wrong", data: [], error: [{ type: "UNKNOWN_ERROR", message: "Something went wrong" }] };
    }
  }

  async subscribeTier(data) {
    try {
      const response = await apiUtils.post(`/api/tiers/subscribe`, data);
      return response.data;
    } catch (err) {
      return err.response
        ? err.response.data
        : { success: false, message: "Something went wrong", data: [], error: [{ type: "UNKNOWN_ERROR", message: "Something went wrong" }] };
    }
  }

  async unsubscribeTier(data) {
    try {
      const response = await apiUtils.post(`/api/tiers/cancel-subscription`, data);
      return response.data;
    } catch (err) {
      return err.response
        ? err.response.data
        : { success: false, message: "Something went wrong", data: [], error: [{ type: "UNKNOWN_ERROR", message: "Something went wrong" }] };
    }
  }

  async getTierById(tierId) {
    try {
      const response = await apiUtils.get(`/api/tiers/${tierId}`);
      return response.data;
    } catch (err) {
      return err.response
        ? err.response.data
        : { success: false, message: "Something went wrong", data: [], error: [{ type: "UNKNOWN_ERROR", message: "Something went wrong" }] };
    }
  }

  async reactivateTier(data) {
    try {
      const response = await apiUtils.post(`/api/tiers/reactivate-subscription`, data);
      return response.data;
    } catch (err) {
      return err.response
        ? err.response.data
        : { success: false, message: "Something went wrong", data: [], error: [{ type: "UNKNOWN_ERROR", message: "Something went wrong" }] };
    }
  }
}
